var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function () {
  var $slider = $(".hero__slider .slider");

  if (!$slider.length) {
    return;
  }

  $slick = $slider.slick({
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    arrows: false,
    dots: true,
    speed: 1000,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    rows: 0,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
  });
};

// Slider - Testimonials
//-----------------------------------------------------------------
mp.sliderTestimonials = function () {
  var $slider = $(".testimonials__slider .slider");

  if (!$slider.length) {
    return;
  }

  $slick = $slider.slick({
    autoplay: true,
    autoplaySpeed: 5000,
    fade: false,
    arrows: true,
    dots: false,
    speed: 1000,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: false,
    rows: 0,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    responsive: [
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
};

// Slider - Services
//-----------------------------------------------------------------
mp.sliderServices = function () {
  var $slider = $(".services__slider .slider");

  if (!$slider.length) {
    return;
  }

  $slick = $slider.slick({
    autoplay: false,
    autoplaySpeed: 5000,
    fade: false,
    arrows: false,
    dots: false,
    speed: 1000,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerPadding: "0px",
    centerMode: false,
    variableWidth: true,
    rows: 0,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
  });
};

// Slider - Articles
//-----------------------------------------------------------------
mp.sliderArticles = function () {
  var $slider = $(".articles__slider .slider");

  if (!$slider.length) {
    return;
  }

  $slick = $slider.slick({
    autoplay: false,
    autoplaySpeed: 3000,
    fade: false,
    arrows: false,
    dots: false,
    speed: 800,
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: false,
    variableWidth: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    rows: 0,
    prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
};

$(document).ready(function () {
  mp.sliderHero();
  mp.sliderTestimonials();
  mp.sliderServices();
  mp.sliderArticles();
});
